import React, { ReactElement, useEffect } from 'react';
import { AUTH0_SCOPE, useExtendedAuth } from '../../util/auth0';
import { useAuth0 } from '@auth0/auth0-react';
import i18next from 'i18next';
import { AUTH0_AUDIENCE, AUTH0_ORGANIZATION_ID } from '../../config';
import { useAuthFetchFromRestAPI } from '../../util/api';

type Props = {
  login: boolean;
};

export const LoginBoxAuth0 = ({ login }: Props): ReactElement => {
  const { user, isLoading, isAuthenticated, getAccessTokenSilently, loginWithPopup } = useAuth0();
  const { handleOnAuthenticated } = useExtendedAuth();
  const { authFetch } = useAuthFetchFromRestAPI();

  const handleLoginPopup = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    try {
      await loginWithPopup({
        authorizationParams: {
          screen_hint: login ? 'login' : 'signup',
          audience: AUTH0_AUDIENCE,
          scope: AUTH0_SCOPE,
          organization: AUTH0_ORGANIZATION_ID ?? undefined,
          ignoreCache: true,
        },
      });
      await authFetch('/api/v1/user-profile/signup', {
        method: 'POST'
      });
    }
    catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const handleEffect = async (): Promise<void> => {
      if (!isLoading && isAuthenticated && user) {
        const token: string = await getAccessTokenSilently();
        handleOnAuthenticated(token, user);
      }
    };
    void handleEffect();
  }, [isAuthenticated, isLoading, user]);

  return (
    <div  className="space-y-4 max-w-sm mx-auto">
      <div className="text-sm text-center">
        <button type="button" className="bg-blue-500 px-4 py-2 w-full" onClick={handleLoginPopup}>
          {isLoading ? i18next.t('loginBox.loginSubmitLabelLoading') : i18next.t('loginBox.loginSubmitLabel')}
        </button>
      </div>
    </div>
  );
};
